import {
  GET_KONSELOR_SESSION_FAIL,
  GET_KONSELOR_SESSION_REQUEST,
  GET_KONSELOR_SESSION_RESET,
  GET_KONSELOR_SESSION_SUCCESS,
  POST_KONSELOR_SESSION_FAIL,
  POST_KONSELOR_SESSION_REQUEST,
  POST_KONSELOR_SESSION_RESET,
  POST_KONSELOR_SESSION_SUCCESS,
} from "../constants/KonselorSessionConstants";

export const km_get_koselor_session_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case GET_KONSELOR_SESSION_REQUEST:
      return { loading: true };
    case GET_KONSELOR_SESSION_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case GET_KONSELOR_SESSION_FAIL:
      return { loading: false, error: action.payload };
    case GET_KONSELOR_SESSION_RESET:
      return {};
    default:
      return state;
  }
};

export const km_post_koselor_session_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case POST_KONSELOR_SESSION_REQUEST:
      return { loading: true };
    case POST_KONSELOR_SESSION_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case POST_KONSELOR_SESSION_FAIL:
      return { loading: false, error: action.payload };
    case POST_KONSELOR_SESSION_RESET:
      return {};
    default:
      return state;
  }
};
